export default {
  LSN_1: {
    title: 'Publicações',
    description: 'Somatória de publicações coletadas na pesquisa.',
  },
  LSN_2: {
    title: 'Usuários',
    description: 'Contagem de usuários únicos que geraram o total de publicações na pesquisa.',
  },
  LSN_3: {
    title: 'Net Promoter Score',
    description: 'Representa o resultado da equação: (publicações positivas / publicações coletadas * 100) - (publicações negativas / publicações coletadas * 100).',
  },
  LSN_4: {
    title: 'Alcance Potencial',
    description: 'Representa 20% da somatória de seguidores/inscritos dos perfis coletados na pesquisa.',
  },
  LSN_5: {
    title: 'Índice de sentimento',
    description: 'Representa o resultado da equação: (publicações positivas + publicações neutras - publicações negativas) / total de publicações.',
  },
  LSN_6: {
    title: 'Distribuição por Sentimento',
    description: 'Divisão das publicações por polaridade positiva, negativa ou neutra.',
  },
  LSN_7: {
    title: 'Distribuição por Gênero',
    description: 'Divisão das publicações por Homem, Mulher e Organização.',
  },
  LSN_8: {
    title: 'Distribuição por Dispositivo',
    description: 'Divisão das publicações por Celular/Tablet e Computador',
  },
  LSN_9: {
    title: 'Distribuição por Canal',
    description: 'Divisão das publicações por canal de coleta (listening).',
  },
  LSN_10: {
    title: 'Principais Influenciadores',
    description: 'Ranking de influenciadores ordenados pela metodologia AAA (grau de influência composto por Atratividade ao Conteúdo, Afinidade com a Pesquisa e Alcance do influenciador).',
  },
  LSN_11: {
    title: 'Publicações mais quentes',
    description: 'Top publicações ordenadas em carrossel pela ponderação entre o tempo da postagem e engajamento recebido recentemente.',
  },
  LSN_12: {
    title: 'Termos correlacionados',
    description: 'Apresenta os principais termos relacionados à pesquisa dentro de um intervalo de tempo. Proximidade indica grau de relação. Tamanho das bolas indica volume de publicações.',
  },
  LSN_13: {
    title: 'Publicações no tempo',
    description: 'Distribuição linear das publicações coletadas ao longo de um período de tempo.',
  },
  LSN_14: {
    title: 'Sentimento no tempo',
    description: 'Distribuição de publicações por sua polaridade ao longo de um período de tempo.',
  },
  LSN_15: {
    title: 'Sentimento por termo',
    description: 'Distribuição de publicações por termos mais mencionados e sua divisão de polaridade.',
  },
  LSN_16: {
    title: 'Sentimento por grupo',
    description: 'Distribuição de publicações pelos Grupos cadastrados na pesquisa mais mencionados e sua divisão de polaridade.',
  },
  LSN_17: {
    title: 'Sentimento por tema',
    description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa mais mencionados e sua divisão de polaridade.',
  },
  LSN_18: {
    title: 'Anotações de texto',
    description: 'Espaço de texto editável livre para escrever análises, legendas e/ou observações.',
  },
  LSN_19: {
    title: 'Inserir Imagem',
    description: 'Componente para inserir imagens por arquivo ou via URLs.',
  },
  LSN_20: {
    title: 'Canais no Tempo',
    description: 'Distribuição das publicações coletadas divididas por canal de coleta ao longo de um período de tempo.',
  },
  LSN_21: {
    title: 'Termômetro de Sentimento',
    description: 'Representa, em forma de gauge, o resultado da equação: (publicações positivas / publicações coletadas * 100) - (publicações negativas / publicações coletadas * 100).',
  },
  LSN_22: {
    title: 'Publicações mais curtidas',
    description: 'Cards em forma de lista ordenada por volume de curtidas em publicações coletadas na pesquisa (inclui posts, publicações e interações).',
  },
  LSN_23: {
    title: 'Publicações mais recentes',
    description: 'Cards em forma de lista ordenada por tempo de publicações coletadas na pesquisa (inclui posts, publicações e interações).',
  },
  LSN_24: {
    title: 'Nuvem de Termos',
    description: 'Apresenta em forma de nuvem os termos mais citados relacionados à pesquisa.',
  },
  LSN_25: {
    title: 'Divisor de seção',
    description: 'Campo de texto para títulos de segmentos e seções do dashboard.',
  },
  LSN_26: {
    title: 'Publicações com mais seguidores',
    description: 'Cards em forma de lista ordenada pela quantidade de seguidores do perfil da publicação.',
  },
  LSN_27: {
    title: 'Publicações com maior Engajamento',
    description: 'Cards em forma de lista ordenada pelo total de engajamento gerado na publicação.',
  },
  LSN_28: {
    title: 'Curtidas',
    description: 'Somatória das curtidas existentes nas publicações coletadas.',
  },
  LSN_29: {
    title: 'Comentários',
    description: 'Somatória dos comentários existentes nas publicações coletadas.',
  },
  LSN_30: {
    title: 'Compartilhamentos',
    description: 'Somatória dos compartilhamentos existentes nas publicações coletadas.',
  },
  LSN_31: {
    title: 'Engajamento',
    description: 'Somatória de todas as ações de engajamento existentes nas publicações coletadas.',
  },
  LSN_32: {
    title: 'Engajamento no tempo',
    description: 'Somatória de todas as ações de engajamento coletadas em publicações e disposta no período de tempo selecionado.',
  },
  LSN_33: {
    title: 'Sentimento por Canal',
    description: 'Distribuição de publicações pelos Canais coletados e sua divisão por polaridade.',
  },
  LSN_34: {
    title: 'Sentimento por Tag',
    description: 'Distribuição de publicações pelas Tags cadastradas na pesquisa e sua divisão por polaridade.',
  },
  LSN_35: {
    title: 'Sentimento por Gênero',
    description: 'Distribuição de publicações por Gênero e sua divisão por polaridade.',
  },
  LSN_36: {
    title: 'Menções por Grupo no Tempo',
    description: 'Distribuição de publicações pelos Grupos cadastrados na pesquisa ao longo do tempo.',
  },
  LSN_37: {
    title: 'Engajamento por Grupo no Tempo',
    description: 'Distribuição da soma das ações de engajamento coletadas nas publicações e classificadas em Grupos da pesquisa ao longo do tempo.',
  },
  LSN_38: {
    title: 'Publicações por Tema no Tempo',
    description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa ao longo do tempo.',
  },
  LSN_39: {
    title: 'Engajamento por Tema no Tempo',
    description: 'Distribuição da soma das ações de engajamento coletadas nas publicações e classificadas em Temas da pesquisa ao longo do tempo.',
  },
  LSN_40: {
    title: 'Publicações por Tag no Tempo',
    description: 'Distribuição e publicações pelas Tags atribuídas na pesquisa ao longo do tempo.',
  },
  LSN_41: {
    title: 'Engajamento por Tag no Tempo',
    description: 'Distribuição da soma das ações de engajamento coletadas nas publicações e classificadas em Tags ao longo do tempo.',
  },
  LSN_42: {
    title: 'Engajamento por Grupo',
    description: 'Distribuição da totalidade de interações nas publicações pelos grupos da pesquisa.',
  },
  LSN_43: {
    title: 'Engajamento por Temas',
    description: 'Distribuição da totalidade de interações nas publicações pelos temas da pesquisa.',
  },
  LSN_44: {
    title: 'Engajamento por Tags',
    description: 'Distribuição da totalidade de interações nas publicações pelas tags da pesquisa',
  },
  LSN_45: {
    title: 'Sentimento no tempo em percentual',
    description: 'Distribuição de publicações pela proporção percentual de positivas, negativas e neutras ao longo de um período de tempo.',
  },
  LSN_46: {
    title: 'Publicações por Grupo no Tempo',
    description: 'Distribuição de publicações pelos Grupos cadastrados na pesquisa.',
  },
  LSN_47: {
    title: 'Publicações por Tema',
    description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa.',
  },
  LSN_48: {
    title: 'Publicações por Tag',
    description: 'Distribuição de publicações pelas Tags atribuídas',
  },
  LSN_49: {
    title: 'Variação de base de fãs (comparativo)',
    description: 'Comparação entre total fãs antes da data de início e na data final do período pesquisado (marcas ou concorrentes).',
  },
  LSN_50: {
    title: 'Total de fãs (comparativo)',
    description: 'Total de Fãs das páginas selecionadas na data final do período pesquisado (marcas ou concorrentes).',
  },
  LSN_51: {
    title: 'Novos fãs (comparativo)',
    description: 'Total de fãs conquistados pelas páginas selecionadas no período pesquisado (marcas ou concorrentes).',
  },
  LSN_52: {
    title: 'Evolução da Base de Fãs (comparativo)',
    description: 'Variação diária de fãs das páginas pesquisadas no período, relativa ao dia anterior (marcas ou concorrentes).',
  },
  LSN_53: {
    title: 'Distribuição por Mídia',
    description: 'Distribuição de publicações por mídia mais mencionados e sua divisão de polaridade.',
  },
  LSN_54: {
    title: 'Equivalência Publicitária',
  },
  LSN_55: {
    title: 'Destaques Portais',
  },
  LSN_56: {
    title: 'Destaques TV',
  },
  LSN_57: {
    title: 'Destaques Impressas',
  },
  LSN_58: {
    title: 'Destaques Rádio',
  },
  LSN_59: {
    title: 'PR Score',
    description: 'Score baseado em uma nota dada às matérias de imprensa.',
  },
  LSN_60: {
    title: 'Saúde da Marca',
    description: 'Soma o percentual de menções positivas e neutras.',
  },
  LSN_61: {
    title: 'Saúde da Marca por Grupo',
    description: 'Soma o percentual de menções positivas e neutras por grupo em comparação com o total de menções.',
  },
  LSN_62: {
    title: 'Saúde da Marca por Tema',
    description: 'Soma o percentual de menções positivas e neutras por grupo em comparação com o total de menções.',
  },
  LSN_63: {
    title: 'Comparativo preço x menções',
  },
  LSN_64: {
    title: 'Comparativo volume x menções',
  },
  LSN_65: {
    title: 'Comparativo preço x sentimento',
  },
  LSN_66: {
    title: 'Importar arquivo',
    description: 'Componente para inserir arquivos por arquivo ou via URLs.',
  },
  LSN_67: {
    title: 'Histórico de importação',
    description: 'Componente para vizualizar os registros do histórico de importação',
  },
  LSN_68: {
    title: 'Busca',
    description: 'Componente para busca textual livre',
  },
  LSN_69: {
    title: 'Relatório de anotações',
    description: 'Componente para auditoria de anotações e mudança de status',
  },
  LSN_70: {
    title: 'Sugestão de Respostas via ChatGPT',
    description: 'Componente para gerar respostas automáticas',
  },
  LSN_71: {
    title: 'Sentimento por Tag com filtro em árvore',
    description: 'Distribuição de publicações pelas Tags cadastradas na pesquisa e sua divisão por polaridade.',
  },
  LSN_72: {
    title: 'Importar comentários',
    description: 'Componente para inserir comentários de publicações via planilha',
  },
  LSN_73: {
    title: 'Canais por grupo',
    description: 'Distribuição de canais pelos Grupos cadastrados na pesquisa.',
  },
  LSN_74: {
    title: 'Publicações por grupo',
    description: 'Distribuição de publicações pelos grupos cadastrados na pesquisa.',
  },
  LSN_75: {
    title: 'Publicações por Tag',
    description: 'Distribuição de publicações pelas Tags atribuídas',
  },
  LSN_76: {
    title: 'Publicações por Tema',
    description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa.',
  },
  LSN_78: {
    title: 'Publicações por tema com filtro personalizado',
    description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa.',
  },
  LSN_79: {
    title: 'Adicionar tags em publicações',
    description: 'Componente para adicionar tags em publicações via importação de planilha',
  },
  LSN_80: {
    title: 'Projeção amostragem de publicações',
    description: 'Projeção do volume de publicações coletadas no período pesquisado, considerando a amostragem de publicações',
  },
};
